import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideUserMinus = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="M22 11h-6" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideUserMinus);
const Memo = memo(ForwardRef);
export default Memo;
